export default [
    {
        key: 'FlowConfigModal',
        getComponent: function () { return import('./plan-node/plan-config'); },
        title: '节点设置',
        width: 800,
    },
    {
        key: 'ManualDistributeModal',
        getComponent: function () { return import('./ManualDistributeModal'); },
        width: 500,
        title: i18n.get('选择下发的审批流'),
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'SyncRuleModal',
        getComponent: function () { return import('./SyncRuleModal'); },
        width: 500,
        title: i18n.get('同步规则'),
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
